"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityConnectionsRoute = exports.EntityConnectionsRouteDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var entity_connections_layout_1 = require("./entity-connections-layout");
var use_app_options_1 = require("../../hooks/use-app-options");
var use_entity_connections_state_1 = require("../../hooks/use-entity-connections-state");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_lang_1 = require("../../hooks/use-lang");
var client_1 = require("@apollo/client");
var graph_connection_mappings_1 = require("../../utils/graph-connection-mappings");
var use_entities_1 = require("../../hooks/use-entities");
var lodash_1 = require("lodash");
exports.EntityConnectionsRouteDefaultProps = {};
// -------- Styles --------->
// -------- Components -------->
var My = {
  Layout: entity_connections_layout_1.EntityConnectionsLayout
};
var EntityConnectionsRoute = function (props) {
  var className = props.className,
    slug = props.slug,
    title = props.title;
  var entities = (0, use_entities_1.useEntities)();
  var appOptions = (0, use_app_options_1.useAppOptions)();
  var _a = __read((0, use_entity_connections_state_1.useEntityConnectionsState)(), 2),
    entityConnectionsState = _a[0],
    setEntityConnectionsState = _a[1];
  var depth = entityConnectionsState.depth;
  var t = (0, use_lang_1.useLang)();
  // const definition = useEntityDefinitionForPluralSlug(entityTypeSlug);
  var definition = (0, use_entity_definition_1.useEntityDefinition)();
  var graphInput = __assign(__assign({}, definition.connections.input), {
    entityConnectionTypes: (0, lodash_1.map)((0, lodash_1.filter)((0, graph_connection_mappings_1.graphConnectionMappings)(appOptions.entityConnectionTypeSets.default), function (mapping) {
      return !!entities[mapping.entityTypeName];
    }), function (mapping) {
      return __assign(__assign({}, mapping), {
        targetEntityTypeNames: (0, lodash_1.filter)(mapping.targetEntityTypeNames, function (tetn) {
          return !!entities[tetn];
        })
      });
    }),
    depth: depth
  });
  var _b = (0, client_1.useQuery)(definition.connections.query, {
      variables: {
        id: slug,
        input: graphInput
      },
      fetchPolicy: 'no-cache'
    }),
    data = _b.data,
    loading = _b.loading;
  var entity = data && data[definition.singleBySlugName];
  react_1.default.useEffect(function () {
    if (!loading) {
      setEntityConnectionsState(__assign(__assign({}, entityConnectionsState), {
        selectedEntity: entity,
        zoomed: false
      }));
    }
  }, [entity]);
  var entityWithDefaults = __assign({
    name: 'Please wait...'
  }, entity || {});
  return react_1.default.createElement(My.Layout, {
    title: title,
    entity: entityWithDefaults,
    loading: loading,
    className: className
  });
};
exports.EntityConnectionsRoute = EntityConnectionsRoute;
exports.EntityConnectionsRoute.defaultProps = exports.EntityConnectionsRouteDefaultProps;